// List and detail
// API related actions
export const FETCHING_SET_SALES = '@@toyota/FETCHING_SET_SALES';
export const FETCHED_SET_SALES = '@@toyota/FETCHED_SET_SALES';
export const FETCHED_SET_SALES_FAILED = '@@toyota/FETCHED_SET_SALES_FAILED';
export const FETCHING_SET_SALES_DETAIL = '@@toyota/FETCHING_SET_SALES_DETAIL';
export const FETCHED_SET_SALES_DETAIL = '@@toyota/FETCHED_SET_SALES_DETAIL';
export const FETCHED_SET_SALES_DETAIL_FAILED = '@@toyota/FETCHED_SET_SALES_DETAIL_FAILED';
export const DOWNLOADING_SET_SALE_DETAIL_FILE = '@@toyota/DOWNLOADING_SET_SALE_DETAIL_FILE';
export const DOWNLOADED_SET_SALE_DETAIL_FILE = '@@toyota/DOWNLOADED_SET_SALE_DETAIL_FILE';
export const DOWNLOADED_SET_SALE_DETAIL_FILE_FAILED = '@@toyota/DOWNLOADED_SET_SALE_DETAIL_FILE_FAILED';
export const DOWNLOADING_SET_SALE_FILE = '@@toyota/DOWNLOADING_SET_SALE_FILE';
export const DOWNLOADED_SET_SALE_FILE = '@@toyota/DOWNLOADED_SET_SALE_FILE';
export const DOWNLOADED_SET_SALE_FILE_FAILED = '@@toyota/DOWNLOADED_SET_SALE_FILE_FAILED';
// complementary actions
export const DELETE_SET_SALES_DATA = '@@toyota/DELETE_SET_SALES_DATA';
export const CHANGE_SET_SALES_LIST_PAGE = '@@toyota/CHANGE_SET_SALES_LIST_PAGE';
export const CHANGE_SET_SALES_LIST_PAGE_SIZE = '@@toyota/CHANGE_SET_SALES_LIST_PAGE_SIZE';
export const DELETE_SET_SALES_DETAIL_DATA = '@@toyota/DELETE_SET_SALES_DETAIL_DATA';
export const CHANGE_SET_SALES_DETAIL_LIST_PAGE = '@@toyota/CHANGE_SET_SALES_DETAIL_LIST_PAGE';
export const CHANGE_SET_SALES_DETAIL_LIST_PAGE_SIZE = '@@toyota/CHANGE_SET_SALES_DETAIL_LIST_PAGE_SIZE';


// Orders
// API related actions
export const FETCHING_SUMMARY_SETS_ORDERS = '@@toyota/FETCHING_SUMMARY_SETS_ORDERS';
export const FETCHED_SUMMARY_SETS_ORDERS = '@@toyota/FETCHED_SUMMARY_SETS_ORDERS';
export const FETCHED_SUMMARY_SETS_ORDERS_FAILED = '@@toyota/FETCHED_SUMMARY_SETS_ORDERS_FAILED';
export const FETCHING_STOCK = '@@toyota/FETCHING_STOCK';
export const FETCHED_STOCK = '@@toyota/FETCHED_STOCK';
export const FETCHED_STOCK_FAILED = '@@toyota/FETCHED_STOCK_FAILED';
export const REQUESTING_ORDER_TO_CPD = '@@toyota/REQUESTING_ORDER_TO_CPD';
export const REQUESTED_ORDER_TO_CPD = '@@toyota/REQUESTED_ORDER_TO_CPD';
export const REQUESTED_ORDER_TO_CPD_FAILED = '@@toyota/REQUESTED_ORDER_TO_CPD_FAILED';
export const NOTHING = '@@toyota/NOTHING';
